<!-- Photo Gallery -->
<div class="row justify-content-center" [ngStyle]="{'height': clsPlaceholderHeight}">

    <ng-container *ngIf="!photoGallery || !photoGallery.photos">
        <h1 class="text-warning"> MISSING PHOTO DATA! </h1>
        <h5 class="text-warning">add the 'photoGallery' parameter to &lt;app-fancy-photo-gallery&gt;!</h5>
    </ng-container>

    <ng-container *ngIf="photoGallery && photoGallery.photos">

        <ng-container *ngIf="mosaic && photoGallery.photos.length >= 4">
            <!-- Front in Frames Section -->
            <div class="overflow-hidden">
                <div class="container">
                    <div class="row justify-content-between align-items-center" >

                        <div class="col-12 position-relative" >
                            <!-- Image Gallery -->
                            <div class="row mx-gutters-2">
                                <div class="col-5 align-self-end px-2 mb-3">
                                    <!-- Fancybox -->
                                    <a class="js-fancybox-{{imageGalleryName}} u-media-viewer" href="javascript:;"
                                       [attr.data-src]="photoGallery.photos[0].highresPath"
                                       [attr.data-fancybox]="imageGalleryName"
                                       [attr.data-caption]="'<h3>' + photoGallery.photos[0].title + '</h3>' + photoGallery.photos[0].description"
                                       data-speed="700">
                                        <img class="img-fluid rounded" appWidth=330 appHeight=220 appLazyload="{{photoGallery.photos[0].thumbnailPath}}"
                                             alt="{{photoGallery.photos[0].altPhotoDescription ? photoGallery.photos[0].altPhotoDescription : photoGallery.photos[0].title}}">

                                        <span class="u-media-viewer__container">
                                          <span class="u-media-viewer__icon bg-{{photoGallery.iconColor}}">
                                            <app-fa-icon iconName="plus" classes="u-media-viewer__icon-inner" height="1" width="1" ></app-fa-icon>
                                          </span>
                                        </span>
                                    </a>
                                    <!-- End Fancybox -->
                                </div>

                                <div class="col-7 px-2 mb-3">
                                    <!-- Fancybox -->
                                    <a class="js-fancybox-{{imageGalleryName}} u-media-viewer" href="javascript:;"
                                       [attr.data-src]="photoGallery.photos[1].highresPath"
                                       [attr.data-fancybox]="imageGalleryName"
                                       [attr.data-caption]="'<h3>' + photoGallery.photos[1].title + '</h3>' + photoGallery.photos[1].description"
                                       data-speed="700">
                                        <img class="img-fluid rounded" appWidth=330 appHeight=220 appLazyload="{{photoGallery.photos[1].thumbnailPath}}"
                                             alt="{{photoGallery.photos[1].altPhotoDescription ? photoGallery.photos[1].altPhotoDescription : photoGallery.photos[1].title}}">

                                        <span class="u-media-viewer__container">
                                          <span class="u-media-viewer__icon bg-{{photoGallery.iconColor}}">
                                            <app-fa-icon iconName="plus" classes="u-media-viewer__icon-inner" height="1" width="1" ></app-fa-icon>
                                          </span>
                                        </span>
                                    </a>
                                    <!-- End Fancybox -->
                                </div>

                                <div class="col-5 offset-1 px-2 mb-3">
                                    <!-- Fancybox -->
                                    <a class="js-fancybox-{{imageGalleryName}} u-media-viewer" href="javascript:;"
                                       [attr.data-src]="photoGallery.photos[2].highresPath"
                                       [attr.data-fancybox]="imageGalleryName"
                                       [attr.data-caption]="'<h3>' + photoGallery.photos[2].title + '</h3>' + photoGallery.photos[2].description"
                                       data-speed="700">
                                        <img class="img-fluid rounded" appWidth=330 appHeight=220 appLazyload="{{photoGallery.photos[2].thumbnailPath}}"
                                             alt="{{photoGallery.photos[2].altPhotoDescription ? photoGallery.photos[2].altPhotoDescription : photoGallery.photos[2].title}}">

                                        <span class="u-media-viewer__container">
                                          <span class="u-media-viewer__icon bg-{{photoGallery.iconColor}}">
                                            <app-fa-icon iconName="plus" classes="u-media-viewer__icon-inner" height="1" width="1" ></app-fa-icon>
                                          </span>
                                        </span>
                                    </a>
                                    <!-- End Fancybox -->
                                </div>

                                <div class="col-5 px-2 mb-3">
                                    <!-- Fancybox -->
                                    <a class="js-fancybox-{{imageGalleryName}} u-media-viewer" href="javascript:;"
                                       [attr.data-src]="photoGallery.photos[3].highresPath"
                                       [attr.data-fancybox]="imageGalleryName"
                                       [attr.data-caption]="'<h3>' + photoGallery.photos[3].title + '</h3>' + photoGallery.photos[3].description"
                                       data-speed="700">
                                        <img class="img-fluid rounded" appWidth=330 appHeight=220 appLazyload="{{photoGallery.photos[3].thumbnailPath}}"
                                             alt="{{photoGallery.photos[3].altPhotoDescription ? photoGallery.photos[3].altPhotoDescription : photoGallery.photos[3].title}}">

                                        <!-- Template for photo that has a thumbnail -->
                                        <span *ngIf="photoGallery.photos.length <= thumbnailCount"
                                              class="u-media-viewer__container">
                                          <span class="u-media-viewer__icon bg-{{photoGallery.iconColor}}">
                                            <app-fa-icon iconName="plus" classes="u-media-viewer__icon-inner" height="1" width="1" ></app-fa-icon>
                                          </span>
                                        </span>

                                        <span *ngIf="photoGallery.photos.length > thumbnailCount"
                                              class="u-media-viewer__container">
                                          <span class="u-media-viewer__icon u-media-viewer__icon--active bg-{{photoGallery.iconColor}}">
                                            <span class="u-media-viewer__icon-inner"><strong
                                                    style="letter-spacing: 0.2em;">+{{photoGallery.photos.length - 4}}</strong></span>
                                          </span>
                                        </span>
                                    </a>
                                    <!-- End Fancybox -->
                                </div>
                                <ng-container *ngFor="let photo of photoGallery.photos.slice(4)">
                                    <!-- Template for photo which exists ONLY in gallery, without thumbnail -->
                                    <img
                                            class="js-fancybox-{{imageGalleryName}} d-none"
                                            alt="{{photo.altPhotoDescription ? photo.altPhotoDescription : photo.title}}"
                                            [attr.data-fancybox]="imageGalleryName"
                                            [attr.data-src]="photo.highresPath"
                                            [attr.data-caption]="'<h3>' + photo.title + '</h3>' + photo.description"
                                            data-speed="700">
                                </ng-container>
                            </div>
                            <!-- End Image Gallery -->
                        </div>
                    </div>
                </div>
            </div>
            <!-- End Front in Frames Section -->
        </ng-container>

        <ng-container *ngIf="!mosaic || photoGallery.photos.length < 4">

            <ng-container *ngFor="let photo of photoGallery.photos; let i = index">
                <!-- Template for photo that has a thumbnail -->
                <!-- NOTE (on ngClass): If there's only 1 photo, let the thumbnail fill the full column. 2 photos, take half. 3+, standard layout. -->
                <div *ngIf="i < thumbnailCount"
                     class="col-12 mb-1"
                     [ngClass]="photoGallery.photos.length == 1 ? '' : (photoGallery.photos.length == 2 ? 'col-md-6' : 'col-md-6 col-lg-4')"
                >
                    <a class="js-fancybox-{{imageGalleryName}} u-media-viewer" href="javascript:;"
                       [attr.data-src]="photo.highresPath"
                       [attr.data-fancybox]="imageGalleryName"
                       [attr.data-caption]="'<h3>' + photo.title + '</h3>' + photo.description"
                       data-speed="700">
                        <img class="img-fluid rounded" appWidth=330 appHeight=220 appLazyload="{{photo.thumbnailPath}}"
                             alt="{{photo.altPhotoDescription ? photo.altPhotoDescription : photo.title}}">

                        <!-- Template for photo that has a thumbnail -->
                        <span *ngIf="i < thumbnailCount || photoGallery.photos.length == thumbnailCount"
                              class="u-media-viewer__container">
                          <span class="u-media-viewer__icon bg-{{photoGallery.iconColor}}">
                                            <app-fa-icon iconName="plus" classes="u-media-viewer__icon-inner" height="1" width="1" ></app-fa-icon>
                          </span>
                        </span>

                        <span *ngIf="i == (thumbnailCount-1) && photoGallery.photos.length > thumbnailCount"
                              class="u-media-viewer__container">
                          <span class="u-media-viewer__icon u-media-viewer__icon--active bg-{{photoGallery.iconColor}}">
                            <span class="u-media-viewer__icon-inner">
                              <strong style="letter-spacing: 0.2em;">+{{photoGallery.photos.length - i - 1}}
                              </strong>
                            </span>
                          </span>
                        </span>
                    </a>
                </div>

                <!-- Template for photo which exists ONLY in gallery, without thumbnail -->
                <img *ngIf="i >= thumbnailCount"
                     class="js-fancybox-{{imageGalleryName}} d-none"
                     alt="{{photo.altPhotoDescription ? photo.altPhotoDescription : photo.title}}"
                     [attr.data-fancybox]="imageGalleryName"
                     [attr.data-src]="photo.highresPath"
                     [attr.data-caption]="'<h3>' + photo.title + '</h3>' + photo.description"
                     data-speed="700">
            </ng-container>
        </ng-container>
    </ng-container>
</div>
<!-- End Photo Gallery -->
